<div class="banner-filled">
  <div class="banner-filled__wrapper">
    <ng-content></ng-content>
  </div>
</div>
